import { HuntAllcott, DmitryTaubinsky, WilliamMorrison } from './authors';

export const OptimalNPI = {
  title: 'When Do "Nudges" Increase Welfare?',
  paperUrl: 'https://www.aeaweb.org/articles?id=10.1257/aer.20231304&from=f',
  repoUrl: 'https://www.openicpsr.org/openicpsr/project/208345/version/V2/view',
  authors: [HuntAllcott, WilliamMorrison, DmitryTaubinsky],
  status: '',
  venue: 'American Economic Review, ',
  citation: 'Vol. 115, No. 5 (May 2025), pages 1555-1596.',
};

export default [OptimalNPI];
